"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParSeQL = exports.CreateView = exports.CreateStage = exports.Create = exports.Copy = exports.Delete = exports.Into = exports.Insert = exports.Merge = exports.Page = exports.Sort = exports.Vfilter = exports.Vagg = exports.Agg = exports.Filter = exports.Op = exports.OpType = exports.Join = exports.Frame = exports.StructRef = exports.TableFunc = exports.WFunc = exports.Func = exports.Else = exports.Then = exports.When = exports.Case = exports.Asterisk = exports.Attr = exports.Const = exports.Cast = exports.Out = exports.In = exports.MatchRecognize = exports.TableSample = exports.Ds = exports.Update = exports.Error = exports.Statement = exports.AntiPatterns = exports.AntiPattern = exports.Expr = exports.TreeNode = void 0;
class TreeNode {
    accept(visitor) {
        visitor.visit_node(this);
    }
    get_raw() {
        return this.raw_input;
    }
}
exports.TreeNode = TreeNode;
class Expr extends TreeNode {
    accept(visitor) {
        visitor.visit_expr(this);
    }
}
exports.Expr = Expr;
class AntiPattern extends TreeNode {
    accept(visitor) {
        super.accept(visitor);
    }
}
exports.AntiPattern = AntiPattern;
class AntiPatterns extends TreeNode {
    accept(visitor) {
        super.accept(visitor);
    }
}
exports.AntiPatterns = AntiPatterns;
class Statement extends TreeNode {
    constructor() {
        super(...arguments);
        this.ds = [];
    }
    accept(visitor) {
        visitor.visit_statement(this);
    }
}
exports.Statement = Statement;
class Error extends TreeNode {
    accept(visitor) {
        visitor.visit_error(this);
    }
}
exports.Error = Error;
class Update extends TreeNode {
    accept(visitor) {
        visitor.visit_update(this);
    }
}
exports.Update = Update;
class Ds extends Expr {
    constructor() {
        super(...arguments);
        this.pos = "";
        this._sameAs = [];
        this.filter = [];
        this.fullref = "";
        this.refdb = "";
        this.refds = "";
        this.refsch = "";
        this.set_op = [];
        this.type = "";
    }
    accept(visitor) {
        visitor.visit_ds(this);
    }
}
exports.Ds = Ds;
class TableSample extends Expr {
    accept(visitor) {
        visitor.visit_tablesample(this);
    }
}
exports.TableSample = TableSample;
class MatchRecognize extends Expr {
    accept(visitor) {
        visitor.visit_matchrecognize(this);
    }
}
exports.MatchRecognize = MatchRecognize;
class In extends TreeNode {
    accept(visitor) {
        visitor.visit_in(this);
    }
}
exports.In = In;
class Out extends TreeNode {
    accept(visitor) {
        visitor.visit_out(this);
    }
}
exports.Out = Out;
class Cast extends Expr {
    constructor() {
        super(...arguments);
        this.data_type = "";
    }
    accept(visitor) {
        visitor.visit_cast(this);
    }
}
exports.Cast = Cast;
class Const extends Expr {
    accept(visitor) {
        visitor.visit_const(this);
    }
}
exports.Const = Const;
class Attr extends Expr {
    accept(visitor) {
        visitor.visit_attr(this);
    }
}
exports.Attr = Attr;
class Asterisk extends Attr {
    accept(visitor) {
        visitor.visit_asterisk(this);
    }
}
exports.Asterisk = Asterisk;
class Case extends Expr {
    accept(visitor) {
        visitor.visit_case(this);
    }
}
exports.Case = Case;
class When extends Expr {
    accept(visitor) {
        visitor.visit_when(this);
    }
}
exports.When = When;
class Then extends Expr {
    accept(visitor) {
        visitor.visit_then(this);
    }
}
exports.Then = Then;
class Else extends Expr {
    accept(visitor) {
        visitor.visit_else(this);
    }
}
exports.Else = Else;
/**
 * done
 * @param node
 */
class Func extends Expr {
    accept(visitor) {
        visitor.visit_func(this);
    }
}
exports.Func = Func;
/**
 * done
 * @param node
 */
class WFunc extends Expr {
    accept(visitor) {
        visitor.visit_wfunc(this);
    }
}
exports.WFunc = WFunc;
/**
 * done
 * @param node
 */
class TableFunc extends Expr {
    accept(visitor) {
        visitor.visit_tablefunc(this);
    }
}
exports.TableFunc = TableFunc;
/**
 * done
 * @param node
 */
class StructRef extends Expr {
    accept(visitor) {
        visitor.visit_structref(this);
    }
}
exports.StructRef = StructRef;
/**
 * done
 * @param node
 */
class Frame extends Expr {
    accept(visitor) {
        visitor.visit_frame(this);
    }
}
exports.Frame = Frame;
/**
 * done
 * @param node
 */
class Join extends Expr {
    accept(visitor) {
        visitor.visit_join(this);
    }
}
exports.Join = Join;
var OpType;
(function (OpType) {
    OpType["ALL"] = "ALL";
    OpType["AMPERSAND"] = "AMPERSAND";
    OpType["AND"] = "AND";
    OpType["ANY"] = "ANY";
    OpType["ASSIGN"] = "ASSIGN";
    OpType["ASTERISK"] = "ASTERISK";
    OpType["BETWEEN"] = "BETWEEN";
    OpType["CASE"] = "CASE";
    OpType["COLLATE"] = "COLLATE";
    OpType["CONCAT"] = "CONCAT";
    OpType["CONCAT_PIPE"] = "CONCAT_PIPE";
    OpType["DIV"] = "DIV";
    OpType["EQ"] = "EQ";
    OpType["EQ_ALL"] = "EQ_ALL";
    OpType["EQ_ANY"] = "EQ_ANY";
    OpType["EXCEPT"] = "EXCEPT";
    OpType["EXISTS"] = "EXISTS";
    OpType["GT"] = "GT";
    OpType["GTE"] = "GTE";
    OpType["GTE_ALL"] = "GTE_ALL";
    OpType["GTE_ANY"] = "GTE_ANY";
    OpType["GT_ALL"] = "GT_ALL";
    OpType["GT_ANY"] = "GT_ANY";
    OpType["IN"] = "IN";
    OpType["INTERSECT"] = "INTERSECT";
    OpType["IS"] = "IS";
    OpType["IS_DISTINCT"] = "IS_DISTINCT";
    OpType["IS_DISTINCT_FROM"] = "IS_DISTINCT_FROM";
    OpType["IS_NOT"] = "IS_NOT";
    OpType["IS_NOT_DISTINCT"] = "IS_NOT_DISTINCT";
    OpType["IS_NOT_DISTINCT_FROM"] = "IS_NOT_DISTINCT_FROM";
    OpType["LIKE"] = "LIKE";
    OpType["LIKE_ALL"] = "LIKE_ALL";
    OpType["LIKE_ANY"] = "LIKE_ANY";
    OpType["LIKE_SOME"] = "LIKE_SOME";
    OpType["LT"] = "LT";
    OpType["LTE"] = "LTE";
    OpType["LTE_ALL"] = "LTE_ALL";
    OpType["LTE_ANY"] = "LTE_ANY";
    OpType["LT_ALL"] = "LT_ALL";
    OpType["LT_ANY"] = "LT_ANY";
    OpType["MATCH"] = "MATCH";
    OpType["MINUS"] = "MINUS";
    OpType["MUL"] = "MUL";
    OpType["NEQ"] = "NEQ";
    OpType["NEQJ"] = "NEQJ";
    OpType["NEQJ_ALL"] = "NEQJ_ALL";
    OpType["NEQJ_ANY"] = "NEQJ_ANY";
    OpType["NEQ_ALL"] = "NEQ_ALL";
    OpType["NEQ_ANY"] = "NEQ_ANY";
    OpType["NOT_EXISTS"] = "NOT_EXISTS";
    OpType["NOT_IN"] = "NOT_IN";
    OpType["NOT_LIKE"] = "NOT_LIKE";
    OpType["NOT_LIKE_ALL"] = "NOT_LIKE_ALL";
    OpType["NOT_LIKE_ANY"] = "NOT_LIKE_ANY";
    OpType["NOT_LIKE_SOME"] = "NOT_LIKE_SOME";
    OpType["NOT_MATCH"] = "NOT_MATCH";
    OpType["NOT_REGEXP"] = "NOT_REGEXP";
    OpType["NOT_REGEXP_ALL"] = "NOT_REGEXP_ALL";
    OpType["NOT_REGEXP_ANY"] = "NOT_REGEXP_ANY";
    OpType["NOT_REGEXP_SOME"] = "NOT_REGEXP_SOME";
    OpType["NOT_RLIKE"] = "NOT_RLIKE";
    OpType["NOT_RLIKE_ALL"] = "NOT_RLIKE_ALL";
    OpType["NOT_RLIKE_ANY"] = "NOT_RLIKE_ANY";
    OpType["NOT_RLIKE_SOME"] = "NOT_RLIKE_SOME";
    OpType["NSEQ"] = "NSEQ";
    OpType["NSEQ_ALL"] = "NSEQ_ALL";
    OpType["NSEQ_ANY"] = "NSEQ_ANY";
    OpType["OR"] = "OR";
    OpType["PARENTHESIS"] = "PARENTHESIS";
    OpType["PERCENT"] = "PERCENT";
    OpType["PLUS"] = "PLUS";
    OpType["REGEX"] = "REGEX";
    OpType["REGEXP"] = "REGEXP";
    OpType["REGEXP_ALL"] = "REGEXP_ALL";
    OpType["REGEXP_ANY"] = "REGEXP_ANY";
    OpType["REGEXP_SOME"] = "REGEXP_SOME";
    OpType["RLIKE"] = "RLIKE";
    OpType["RLIKE_ALL"] = "RLIKE_ALL";
    OpType["RLIKE_ANY"] = "RLIKE_ANY";
    OpType["RLIKE_SOME"] = "RLIKE_SOME";
    OpType["SETMINUS"] = "SETMINUS";
    OpType["SLASH"] = "SLASH";
    OpType["UNION"] = "UNION";
    OpType["UNION_ALL"] = "UNION_ALL";
    OpType["UNION_DISTINCT"] = "UNION_DISTINCT";
})(OpType = exports.OpType || (exports.OpType = {}));
/**
 * done
 * @param node
 */
class Op extends Expr {
    accept(visitor) {
        visitor.visit_op(this);
    }
}
exports.Op = Op;
/**
 * done
 * @param node
 */
class Filter extends TreeNode {
    constructor() {
        super(...arguments);
        this.op = null;
    }
    accept(visitor) {
        visitor.visit_filter(this);
    }
}
exports.Filter = Filter;
/**
 * done
 * @param node
 */
class Agg extends TreeNode {
    accept(visitor) {
        visitor.visit_agg(this);
    }
}
exports.Agg = Agg;
/**
 * done
 * @param node
 */
class Vagg extends TreeNode {
    accept(visitor) {
        visitor.visit_agg(this);
    }
}
exports.Vagg = Vagg;
/**
 * done
 * @param node
 */
class Vfilter extends TreeNode {
    accept(visitor) {
        visitor.visit_vfilter(this);
    }
}
exports.Vfilter = Vfilter;
/**
 * done
 * @param node
 */
class Sort extends TreeNode {
    accept(visitor) {
        visitor.visit_sort(this);
    }
}
exports.Sort = Sort;
class Page extends TreeNode {
    accept(visitor) {
        visitor.visit_page(this);
    }
}
exports.Page = Page;
class Merge extends TreeNode {
    accept(visitor) {
        visitor.visit_merge(this);
    }
}
exports.Merge = Merge;
class Insert extends TreeNode {
    accept(visitor) {
        visitor.visit_insert(this);
    }
}
exports.Insert = Insert;
class Into extends TreeNode {
    accept(visitor) {
        visitor.visit_into(this);
    }
}
exports.Into = Into;
class Delete extends TreeNode {
    accept(visitor) {
        visitor.visit_delete(this);
    }
}
exports.Delete = Delete;
class Copy extends TreeNode {
    accept(visitor) {
        visitor.visit_copy(this);
    }
}
exports.Copy = Copy;
class Create extends TreeNode {
    accept(visitor) {
        visitor.visit_create(this);
    }
}
exports.Create = Create;
class CreateStage extends TreeNode {
    accept(visitor) {
        visitor.visit_create_stage(this);
    }
}
exports.CreateStage = CreateStage;
class CreateView extends TreeNode {
    accept(visitor) {
        visitor.visit_create_view(this);
    }
}
exports.CreateView = CreateView;
class ParSeQL extends TreeNode {
    accept(visitor) {
        visitor.visit_parseql(this);
    }
}
exports.ParSeQL = ParSeQL;
